// Microsoft Advertising UET tag. Loads only when VITE_BING_UET_ID is set, so
// dev/preview builds never fire tracking. enableAutoSpaTracking reports SPA
// route changes as page views, which is what Microsoft Ads destination-URL
// conversion goals (e.g. /dashboard?marketing_billing=success) key off.
const UET_ID = import.meta.env.VITE_BING_UET_ID || '';

export function initUet() {
  if (!UET_ID || typeof window === 'undefined' || window.uetq) return;
  (function (w, d, t, r, u) {
    let f, n, i;
    w[u] = w[u] || [];
    f = function () {
      const o = { ti: UET_ID, enableAutoSpaTracking: true };
      o.q = w[u];
      w[u] = new w.UET(o);
      w[u].push('pageLoad');
    };
    n = d.createElement(t);
    n.src = r;
    n.async = 1;
    n.onload = n.onreadystatechange = function () {
      const s = this.readyState;
      if (s && s !== 'loaded' && s !== 'complete') return;
      f();
      n.onload = n.onreadystatechange = null;
    };
    i = d.getElementsByTagName(t)[0];
    i.parentNode.insertBefore(n, i);
  })(window, document, 'script', 'https://bat.bing.com/bat.js', 'uetq');
}

// Custom conversion event (e.g. uetTrack('signup')). Safe no-op when the tag
// isn't loaded.
export function uetTrack(action, params = {}) {
  if (!UET_ID || typeof window === 'undefined') return;
  window.uetq = window.uetq || [];
  window.uetq.push('event', action, params);
}
